import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { eventApi } from '@/enitites/event'
import IconLike from '@/shared/icons/IconLike.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleLike',
  props: {
    eventId: null,
    isLiked: { type: Boolean },
    totalLikes: null,
    colorSvg: null
  },
  emits: ["update:is-liked", "update:total-likes"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:is-liked', value: boolean): void
  (e: 'update:total-likes', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventId: number
  isLiked: boolean
  totalLikes?: number
  colorSvg?: string
};

// @ts-expect-error JS file




const getUserDB = computed(() => store.getters.getUserDB)
const router = useRouter()
const route = useRoute()

const handleToggleLike = async () => {
  if (!getUserDB.value) {
    await router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
    return
  }
  const previousState = props.isLiked
  const previousTotalLikes = props.totalLikes

  emit('update:is-liked', !previousState)
  if (props.totalLikes !== undefined) {
    emit('update:total-likes', previousTotalLikes !== undefined ? previousTotalLikes + (previousState ? -1 : 1) : 1)
  }

  const response = await eventApi.toggleLike(props.eventId)

  if (response === undefined) {
    emit('update:is-liked', previousState)
    if (props.totalLikes !== undefined) {
      emit('update:total-likes', previousTotalLikes)
    }
  }
}

return { __sfc: true,props, emit, getUserDB, router, route, handleToggleLike, IconLike }
}

})